import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, MapIcon, FolderIcon, BookOpenIcon, ListChecksIcon, AlertCircleIcon } from 'lucide-react';
export function IncludesSection() {
  const features = [{
    icon: ListChecksIcon,
    title: 'Checklist Maestro de Arquitectura Empresarial'
  }, {
    icon: MapIcon,
    title: 'Mapa de Ejecución paso a paso'
  }, {
    icon: FolderIcon,
    title: 'Sistema Búnker Digital (organización documental profesional)'
  }, {
    icon: BookOpenIcon,
    title: 'Glosario empresarial completo'
  }, {
    icon: CheckCircleIcon,
    title: 'Procesos ejecutables para cada pilar'
  }, {
    icon: CheckCircleIcon,
    title: 'Qué portales oficiales utilizar'
  }, {
    icon: CheckCircleIcon,
    title: 'Qué formularios completar'
  }, {
    icon: AlertCircleIcon,
    title: 'Qué errores evitar'
  }];
  return <section className="w-full bg-bg-primary py-12 md:py-20 px-4" data-id="element-101">
      <div className="max-w-6xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-103">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-104">
            Sistema completo de ejecución empresarial
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-105">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.05
          }} className="bg-bg-card border border-accent-primary border-opacity-10 rounded-lg p-4 md:p-6" data-id="element-106">
                <div className="flex items-start space-x-3 md:space-x-4" data-id="element-107">
                  <div className="flex-shrink-0" data-id="element-108">
                    <Icon className="h-5 w-5 md:h-6 md:w-6 text-accent-primary" aria-hidden="true" data-id="element-109" />
                  </div>
                  <p className="text-sm md:text-base text-text-primary font-medium leading-relaxed" data-id="element-110">
                    {feature.title}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}